import { emptySplitApi } from 'emptySplitApi'
import { Recommendation } from 'store/strategy/types'

const recommendationApi = emptySplitApi.injectEndpoints({
  endpoints: build => ({
    getRecommendation: build.query<Recommendation, { code: string }>({
      query: ({ code }) => ({
        url: `recommendations/${code}`,
      }),
    }),
  }),
})

export const { useGetRecommendationQuery } = recommendationApi
